import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { TabsSkeletonProps } from './TabsSkeleton.types';

const TabsSkeleton: React.FC<TabsSkeletonProps> = ({ className, size }) => {
  return (
    <div className={`p4 flex flex-row ${className}`}>
      {Array(size)
        .fill(0)
        .map((_el, ind) => (
          <Skeleton
            variant="rect"
            key={ind}
            width={120}
            height={30}
            className="ml1 br1"
          />
        ))}
    </div>
  );
};

export default TabsSkeleton;
export { TabsSkeletonProps };
